import React, { useEffect, useState } from 'react';
import { CTaskFile } from 'shared/components/TaskTracker/CTaskFile';
import './index.scss';

type PropsType = {
    files: string[];
    newFiles: File[];
    disabled: boolean;
    onChangeFiles: (files: string[]) => void;
    onChangeNewFiles: (files: File[]) => void;
    onError: (error: string) => void;
};

const NewFile = ({ file, onDelete }: { file: File; onDelete?: () => void }) => {
    const [url, setUrl] = useState('');
    useEffect(() => {
        const objectUrl = URL.createObjectURL(file);
        setUrl(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
    }, [file]);
    return <CTaskFile name={file.name} url={url} onDelete={onDelete}/>;
};

export const CCommentFiles = ({
    files, newFiles, disabled, onChangeFiles, onChangeNewFiles, onError
}: PropsType) => {
    const count = files.length + newFiles.length;
    if (count === 0) {
        return null;
    }

    return (
        <div className="c-comment-files">
            <div className="c-comment-files__items">
                {files.map((file, index) => (
                    <CTaskFile key={file}
                        name={file}
                        url={file}
                        onDelete={disabled ? undefined : () => {
                            onChangeFiles(files.filter((_, i) => i !== index));
                            onError('');
                        }}
                    />
                ))}
                {newFiles.map((file, index) => (
                    <NewFile key={`${file.name}-${file.lastModified}-${index}`}
                        file={file}
                        onDelete={disabled ? undefined : () => {
                            onChangeNewFiles(newFiles.filter((_, i) => i !== index));
                            onError('');
                        }}
                    />
                ))}
            </div>
        </div>
    );
};
